var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('maptivateInfoButton',{attrs:{"Site_Marker_Number":_vm.Site_Marker_Number,"isPopup":_vm.isPopup,"butType":"galleryOpen","width":_vm.width,"color":_vm.appSettings.mediaButtonColor,"icon":"mdi-film","title":"View Gallery","clickfunction":function () {
      _vm.loadImageGallery(_vm.Site_Marker_Number);
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }